// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ExtraDiscountPrize = (tag, _1) => ({tag, _1});
const PriceDiscountIsSymbol = {reflectSymbol: () => "PriceDiscount"};
const PercentageDiscountIsSymbol = {reflectSymbol: () => "PercentageDiscount"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const prizeIsSymbol = {reflectSymbol: () => "prize"};
const ExtraDiscountIsSymbol = {reflectSymbol: () => "ExtraDiscount"};
const PriceDiscount = value0 => $ExtraDiscountPrize("PriceDiscount", value0);
const PercentageDiscount = value0 => $ExtraDiscountPrize("PercentageDiscount", value0);
const ExtraDiscount = x => x;
const newtypeExtraDiscount_ = {Coercible0: () => {}};
const hasFieldExtraDiscount = dictHasField => dictHasField;
const eqExtraDiscountPrize = {
  eq: x => y => {
    if (x.tag === "PriceDiscount") {
      if (y.tag === "PriceDiscount") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "PercentageDiscount") {
      if (y.tag === "PercentageDiscount") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const eqExtraDiscount = {
  eq: x => y => x.name === y.name && (() => {
    if (x.prize.tag === "PriceDiscount") {
      if (y.prize.tag === "PriceDiscount") { return x.prize._1 === y.prize._1; }
      return false;
    }
    if (x.prize.tag === "PercentageDiscount") {
      if (y.prize.tag === "PercentageDiscount") { return x.prize._1 === y.prize._1; }
      return false;
    }
    return false;
  })()
};
const genericExtraDiscountPrize = {
  to: x => {
    if (x.tag === "Inl") { return $ExtraDiscountPrize("PriceDiscount", x._1); }
    if (x.tag === "Inr") { return $ExtraDiscountPrize("PercentageDiscount", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "PriceDiscount") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "PercentageDiscount") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showExtraDiscountPrize = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dMoney$dRounded.toString(v)]})(PriceDiscountIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})(PercentageDiscountIsSymbol);
    return x => {
      if (x.tag === "PriceDiscount") { return $0["genericShow'"](x._1); }
      if (x.tag === "PercentageDiscount") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeExtraDiscountPrize = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PriceDiscountIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Data$dInt.unsafeClamp(Data$dNumber.round(Unscramble.decodeNumber(x.contents) * 100.0))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(PercentageDiscountIsSymbol)({unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeInt(x.contents)})))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $ExtraDiscountPrize("PriceDiscount", $1._1); }
      if ($1.tag === "Inr") { return $ExtraDiscountPrize("PercentageDiscount", $1._1); }
      $runtime.fail();
    };
  })()
};
const genericExtraDiscount = {to: x => x, from: x => x};
const showExtraDiscount = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ name: " + Data$dShow.showStringImpl(v.name) + ", prize: " + showExtraDiscountPrize.show(v.prize) + " " + "}"]
    })(ExtraDiscountIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeExtraDiscount = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(prizeIsSymbol)(unscrambleDecodeExtraDiscountPrize)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeExtraDiscountPrize = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericExtraDiscountPrize)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(PriceDiscountIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(PercentageDiscountIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const encodeExtraDiscount = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericExtraDiscount)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ExtraDiscountIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(prizeIsSymbol)({
      encodeWithOptions: v => encodeExtraDiscountPrize.encode
    }))(nameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeExtraDiscountPrize = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericExtraDiscountPrize)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PriceDiscountIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PercentageDiscountIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
const decodeExtraDiscount = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericExtraDiscount)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ExtraDiscountIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(prizeIsSymbol)({
    decodeWithOptions: v => decodeExtraDiscountPrize.decode
  })())(nameIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $ExtraDiscountPrize,
  ExtraDiscount,
  ExtraDiscountIsSymbol,
  PercentageDiscount,
  PercentageDiscountIsSymbol,
  PriceDiscount,
  PriceDiscountIsSymbol,
  decodeExtraDiscount,
  decodeExtraDiscountPrize,
  encodeExtraDiscount,
  encodeExtraDiscountPrize,
  eqExtraDiscount,
  eqExtraDiscountPrize,
  genericExtraDiscount,
  genericExtraDiscountPrize,
  hasFieldExtraDiscount,
  nameIsSymbol,
  newtypeExtraDiscount_,
  prizeIsSymbol,
  showExtraDiscount,
  showExtraDiscountPrize,
  unscrambleDecodeExtraDiscount,
  unscrambleDecodeExtraDiscountPrize
};
